import { useCallback, useMemo } from 'react';
import {
  fieldAddProductVulcan,
  fieldOrderIdTSB,
  fieldUnitNumber,
  fieldUnitType,
  prequalificationField,
  resetFieldOfVulcan,
  secureBusinessPlanVulcan,
  Prequalification,
  CONSTANT
} from '../../utils/constant';
import { getFieldValue } from '../utils';
import { getLocale } from '../../misc';
import EN from '../../../EN.json';
import FR from '../../../FR.json';

const disableOptions = (options, targets, value) => {
  const updatedOptions = [...options];
  targets.forEach(target => {
    updatedOptions.forEach(option => {
      if (option.fields.value === target) {
        // eslint-disable-next-line no-param-reassign
        option.fields.disabledOption = value;
      }
    });
  });
  return updatedOptions;
};

const CustomerHelpers = ({ fieldName, formFields, fields, setResetSection, channelName }) => {
  const locale = getLocale();
  const {
    vulcanWebform: {
      businessWifiVul,
      vulBusinessWifi,
      vulFibreInternet,
      vulBusinessConnect,
      vulTSB,
      vulSigningAuthority,
      vulServiceAddress
    }
  } = locale === 'en-US' ? EN : FR;
  const {
    KEYS: {
      CHANNELS: {
        CORP_STORE
      }
    }
  } = CONSTANT;

  let isProductDisable;

  const addProductVulcanValue = getFieldValue(
    fieldAddProductVulcan,
    formFields
  );
  const valueofTSBId = getFieldValue(fieldOrderIdTSB, formFields);

  const existingVulcanProduct = getFieldValue('productVulcan', formFields);
  
  // if (
  //   fieldName === vulSigningAuthority ||
  //   fieldName === vulServiceAddress
  // ) {
  //   if (addProductVulcanValue.includes(vulBusinessConnect) || valueofTSBId) {
  //     resetFieldOfVulcan.forEach(value => {
  //       formFields[value].isRequired = false;
  //       formFields[value].value = '';
  //     });
  //     formFields[fieldUnitNumber].value = '';
  //     formFields[fieldUnitType].value = '';
  //     return true;
  //   } else {
  //     resetFieldOfVulcan.forEach(value => {
  //       formFields[value].isRequired = true;
  //     });
  //   }
  // }
  
  if (
    fieldName === fieldAddProductVulcan &&
    channelName === CORP_STORE &&
    fields &&
    Array.isArray(fields.options)
  ) {
    fields.options = fields.options.filter(
      option =>
        option &&
        option.fields &&
        option.fields.value !== vulBusinessConnect
    );
  }

  if (fieldName === fieldAddProductVulcan) {
    if (!formFields[fieldAddProductVulcan].value) {
      formFields[fieldAddProductVulcan].value = [
        vulFibreInternet,
        vulBusinessWifi
      ];
      setResetSection(true);
    }

    if (existingVulcanProduct) {
      isProductDisable = existingVulcanProduct.includes(
        businessWifiVul
      );
    }
    if (isProductDisable) {
      disableOptions(
        formFields[fieldAddProductVulcan].options,
        [vulFibreInternet],
        true
      );
      disableOptions(
        formFields[fieldAddProductVulcan].options,
        [vulBusinessWifi],
        false
      );
    } else {
      disableOptions(
        formFields[fieldAddProductVulcan].options,
        [vulFibreInternet, vulBusinessWifi],
        true
      );
    }
    // Reset the prequalification form fields
    if (
      addProductVulcanValue &&
      !addProductVulcanValue.includes(vulTSB)
    ) {
      prequalificationField.map(fieldName => {
        formFields[fieldName].value = undefined;
      });
      formFields['isHomeBased'].value = undefined;
    }
  }
  if (valueofTSBId && fieldName === 'secureBusinessProductVulcan') {
    formFields[secureBusinessPlanVulcan].isRequired = false;
    formFields[secureBusinessPlanVulcan].value = '';
    formFields.smokeDetectorWarningNoteVulcan.isVisible = false;
    return true;
  }
  if (valueofTSBId) {
    if (fieldName === 'prequalification') {
      // eslint-disable-next-line no-lone-blocks
      prequalificationField.map(fieldName => {
        formFields[fieldName].isRequired = false;
      });
      formFields['isHomeBased'].isRequired = false;

      return true;
    }
  }
};

export default CustomerHelpers;
